import { render, staticRenderFns } from "./PermissionAction.vue?vue&type=template&id=5b159fa0&"
import script from "./PermissionAction.vue?vue&type=script&lang=ts&"
export * from "./PermissionAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports